import { Controller } from 'stimulus'

// this controller for referesh all feather icon for show on screen
export default class extends Controller {
  
  connect() {
    this.refereshIcons()
  }

  refereshIcons(){
    setTimeout(() => {
      if (typeof feather !== 'undefined') {
        feather.replace({}, this.element)
      }
    }, 100)
  }
}
